module.exports = __webpack_public_path__ + "static/media/mobileIcon.633745e1.svg";